import { StepConnector, withStyles } from '@material-ui/core'
import styled from 'styled-components'
import { accent } from '../../../../../../../Styles/colors'
import {
  hFlex,
  horizontalSplit,
  overlay,
  singleLineText,
  vFlex,
} from '../../../../../../../Styles/style-helpers'
import { H3, H4, H5, Text } from '../../../../../../../Styles/typography'

export const GroupRegEl = styled.div`
  ${overlay};
  position: fixed;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(10px);
  ${vFlex};

  .regModal {
    width: 75%;
    height: 85%;
    background-color: white;
    position: relative;
    border-radius: 1em;
    overflow: auto;
    font-size: 0.85em;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 1.5em;
    }

    > h3 {
      width: 100%;
      text-align: center;
      padding: 1em 15%;
    }

    .MuiStepper-root {
      position: relative;
      width: 100%;
      bottom: 0;
      left: 0;
      padding-bottom: 0;
      margin-bottom: 2em;

      .MuiStepLabel-label {
        margin-top: 0.25em;
      }
    }

    .modalContent {
      padding: 1em 5%;
      ${vFlex};
      justify-content: space-between;
      align-items: inherit;
      overflow: auto;
    }

    .pendingRequestContent {
      ${vFlex}
      > ${H3} {
        margin: 1em 0;
      }
    }

    .enrolledContent > .classTimings {
      .headerContainer {
        opacity: 0;
        // ${hFlex}
        // justify-content: flex-start;

        // .defaultButton {
        //   height: 3em;
        //   ${singleLineText}
        //   width: 25em;
        //   margin: 0 2em 0.75em;
        //   font-size: 0.8em;
        // }

        // .timingsHeader {
        //   width: 50%;
        //   margin: 1.5em 0 1.75em;
        //   padding: 10px 0;
        // }

        // .inputWrapper {
        //   width: 50%;
        // }
      }

      .week {
        margin-bottom: 2em;

        .classes {
          ${horizontalSplit(3, 1.5)}
        }
      }

      .pageControl {
        width: 100%;
        ${hFlex};
        justify-content: center;

        .defaultButton {
          width: 9em;
          height: 3em;
          margin: 0 1em;
        }
      }
    }

    .back-btn {
      ${hFlex};
      position: absolute;
      top: 3em;
      left: 2em;
      cursor: pointer;
      z-index: 10;

      svg {
        margin-right: 0.25em;
      }
    }
  }
`

export const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector)

export const FirstStepEl = styled.div`
  > ${H4} {
    width: 100%;
    margin-bottom: 1.5em;
    padding-left: 0.25em;
    text-align: center;
  }

  .batches {
    ${hFlex};
    position: relative;
    width: 100%;
    justify-content: flex-start;
    align-items: start;
    overflow-x: auto;
  }
`

export const BatchEl = styled.div`
  min-width: 20em;
  border-radius: 0.5em;
  box-shadow: rgba(0, 0, 0, 0.25) 0 0 0.5em;
  margin: 1em;
  padding: 1.5em;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.8)};

  ${H4} {
    margin-bottom: 0;
  }

  ${H5} {
    padding: 0.25em 0;
    margin: 1em 0 0.5em;
    border-bottom: 1px solid rgb(231, 231, 231);
  }

  ${Text} {
    margin: 0.5em 0;

    span {
      color: ${accent};
    }
  }

  .fomo {
    text-align: right;
    color: red;
    font-size: 1.1em;
  }

  .actions {
    width: 100%;
    ${hFlex};
    justify-content: flex-end;
    margin-top: 1em;
  }
`

export const SecondStepEl = styled.div`
  ${vFlex};
  width: 100%;
  position: relative;
  overflow: auto;
  justify-content: flex-start;
  padding-bottom: 1em;

  > ${H4} {
    width: 100%;
    text-align: center;
    margin-bottom: 1em;
    padding-left: 0.25em;
  }

  .action-btns {
    ${hFlex};
    justify-content: flex-end;
    margin-top: 1em;

    .retake-btn {
      ${hFlex};
      cursor: pointer;
      margin-right: 1.5em;

      svg {
        margin-right: 0.25em;
      }
    }
  }

  .video-container {
    width: 50%;
  }
`

export const ThirdStepEl = styled.div`
  ${vFlex};
  width: 100%;
  position: relative;
  max-height: 100%;
  justify-content: flex-start;
  overflow: auto;

  form {
    ${vFlex};
    width: 60%;
    padding: 2em 0;

    .textarea {
      border-bottom: none !important;
    }
  }
`

export const FourthStepEl = styled.div`
  ${vFlex};
  position: relative;
  width: 100%;
  overflow: auto;
  justify-content: flex-start;

  .content {
    ${vFlex};
    width: 100%;
    margin-top: 1em;
    padding-bottom: 0.5em;

    .preview {
      width: 100%;
      ${hFlex};
      align-items: unset;

      .batch-info {
        flex: 1;
        margin-left: 1.5em;

        ${BatchEl} {
          margin: 2em 2em 0 0;
        }
      }

      .right {
        flex: 1;

        .enroll-message {
          margin-bottom: 2em;

          .inputWrapper {
            margin: 0;

            .placeholder {
              display: none;
            }
          }
        }

        .video-player {
          > div {
            height: auto !important;
            margin-top: 2em;
            border-radius: 0.5em;
            overflow: hidden;
          }
        }
      }
    }

    .action-btn {
      width: 100%;
      ${hFlex};
      justify-content: flex-end;
      padding: 1em 0;
    }
  }

  h6 {
    margin-bottom: 0.5em;
  }

  .action-btns {
    ${hFlex};
    width: 100%;
    justify-content: flex-end;

    > button {
      margin-right: 1em;
    }
  }
`
